import AbstractRequestTask from './AbstractRequestTask';

class WorkflowStartTask extends AbstractRequestTask {
  constructor(params) {
    super();
    this.params = params;
    this.name = 'WorkflowStartTask';
  }

  getUrl() {
    const url_dominio_microfwk = window.getConfig.url_dominio_microfwk;
    return `${url_dominio_microfwk}${this.params.linkworkflowstart}`;
  }

  getParams() {
    const params = super.getParams();
    this.params = Object.assign(params, this.params);
    const aux = Object.assign({}, this.params);
    if (aux.linkworkflowstart) delete aux.linkworkflowstart;
    return aux;
  }

  success(data, b) {
    const isValid = super.success(data, b);
    if (!isValid) {
      return this.reject(data, b);
    }
    this.resolve(data);
  }
}

export default WorkflowStartTask;
